<template>
  <div id="app-monitoring-element" />
</template>

<script>
/**
 * Creates a hidden element to monitor the App.
 * This is a requirement from DevOps, and it should be always present.
 * This will allow an automated Selenium script to regularly check if
 * the element is rendering in production environments.
 *
 * @component
 * @example
 * <app-monitoring-tag />
 */
export default {
  name: "AppMonitoringTag"
};
</script>

<style scoped lang="scss">
#app-monitoring-element {
  display: none;
}
</style>
